import omitDeep from 'omit-deep-lodash';
import { ApolloClient, ApolloLink, createHttpLink, from, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { ServerError } from '@apollo/client/link/utils';
import { isLoggedIn } from '../../shared/libs/auth/auth';

const authenCode = {
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    HEADER_ACCOUNT_MISSING: 'HEADER_ACCOUNT_MISSING',
    ACCESS_DENIED: 'ACCESS_DENIED',
};

const middleware = new ApolloLink((operation, forward) => {
    operation.variables = omitDeep(operation.variables, '__typename');
    const accountId = window.location.pathname.split('/')[3];
    // add the authorization to the headers
    if (accountId !== undefined && !isNaN(parseInt(accountId))) {
        operation.setContext(({ headers = {} }) => ({
            headers: {
                ...headers,
                account: accountId, // TODO waiting handle
            },
        }));
    }

    return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
        for (const err of graphQLErrors) {
            switch (err.extensions.code) {
                case authenCode.UNAUTHENTICATED:
                    const uri = window.encodeURIComponent(`${window.location.href}`);
                    window.location.href = `${process.env.REACT_APP_AUTH_ENDPOINT}/login?redirect_uri=${uri}`;
                    break;
                case authenCode.ACCESS_DENIED:
                    if (!isLoggedIn()) {
                        const uri = window.encodeURIComponent(`${window.location.href}`);
                        window.location.href = `${process.env.REACT_APP_AUTH_ENDPOINT}/login?redirect_uri=${uri}`;
                    } else {
                        window.location.href = process.env.REACT_APP_ENDPOINT as string;
                    }
                    break;
                case authenCode.HEADER_ACCOUNT_MISSING:
                    window.location.href = process.env.REACT_APP_ENDPOINT as string;
                    break;
            }
        }
    }

    if (networkError) {
        const context = operation.getContext();
        const serverError = networkError as ServerError;
        if (
            [400, 404, 500].includes(serverError.statusCode) &&
            context.skipHandlers &&
            !context.skipHandlers.includes(serverError.statusCode)
        ) {
            // TODO handle network error
            // Example how to use skipHandlers
            // const { data: userData } = useGetCurrentUserQuery({ context: { skipHanlder: [400] } });
        }
    }
});

const link = createHttpLink({
    uri: process.env.REACT_APP_CORE_API_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    credentials: 'include',
});

const client = new ApolloClient({
    cache: new InMemoryCache({
        //addTypename: false,
        typePolicies: {
            Design: {
                fields: {
                    categories: {
                        merge: false,
                    },
                },
            },
            SiteDesign: {
                keyFields: ['accountId'],
            },
        },
    }),
    link: from([middleware, errorLink, link]),
});
export default client;
